var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11796",
    "data-name": "Group 11796",
    transform: "translate(2.124 8.123)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_76",
    "data-name": "Ellipse 76",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(-0.124 -6.123)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49524",
    "data-name": "Path 49524",
    d: "M145.213,149.729a4.488,4.488,0,0,1-3.2-1.323l-6.669-6.666-6.669,6.67a4.52,4.52,0,1,1-6.392-6.392l6.669-6.67-6.67-6.669a4.52,4.52,0,1,1,6.392-6.392l6.67,6.669,6.669-6.67a4.52,4.52,0,1,1,6.392,6.392l-6.669,6.67,6.67,6.669a4.518,4.518,0,0,1-3.2,7.712Z",
    transform: "translate(-107.473 -113.472)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImg);
export default __webpack_public_path__ + "static/media/error-img.ffa2714fba447a601b60a02f65c65fc3.svg";
export { ForwardRef as ReactComponent };